import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';
import { supabase } from '../config/supabase';
import { Link } from 'react-router-dom';

export default function Tools() {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTools = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('tools')
          .select('*')
          .order('order_index', { ascending: true });

        if (error) throw error;
        setTools(data || []);
      } catch (error) {
        console.error('Error fetching tools:', error);
        setError('ไม่สามารถโหลดข้อมูลเครื่องมือได้');
      } finally {
        setLoading(false);
      }
    };

    fetchTools();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Helmet>
        <title>เครื่องมือทั้งหมด</title>
      </Helmet>

      <main className="flex-grow container mx-auto px-4 py-12">
        <div className="mb-16">
          <h1 className="text-4xl font-bold mb-4 text-center">เครื่องมือทั้งหมด</h1>
          <p className="text-gray-400 text-xl mb-8 text-center">เครื่องมือที่จะช่วยให้การทำงานของคุณง่ายขึ้น</p>
          
          {/* ปุ่มเข้า Discord และ Facebook */}
          <div className="flex justify-center gap-4 mb-16">
            <a 
              href="https://discord.com/invite/MxgKZkydXJ"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-6 py-4 bg-[#5865F2] hover:bg-[#4752C4] text-white rounded-xl font-medium text-lg transition-colors"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
              </svg>
              เข้าร่วม Discord
            </a>
            
            <a 
              href="https://www.facebook.com/aiunlockedvip"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-6 py-4 bg-[#1877F2] hover:bg-[#0E65D9] text-white rounded-xl font-medium text-lg transition-colors"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
              เฟสบุ๊ค
            </a>
          </div>

          {/* แสดงข้อความโหลดหรือข้อผิดพลาด */}
          {loading && (
            <div className="flex justify-center items-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
            </div>
          )}

          {error && (
            <div className="bg-red-500/20 border border-red-500 text-red-300 p-4 rounded-lg mb-8">
              <p>{error}</p>
            </div>
          )}

          {/* แสดงรายการเครื่องมือ */}
          {!loading && !error && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {tools.map((tool, index) => (
                <div key={tool.id} className="bg-gray-800 rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow relative">
                  {/* แสดงป้ายยอดนิยมสำหรับ 6 อันดับแรก */}
                  {index < 6 && (
                    <div className="absolute top-0 right-0">
                      <div className="bg-gradient-to-r from-yellow-500 to-amber-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg shadow-md">
                        ยอดนิยม
                      </div>
                    </div>
                  )}
                  <div className="p-6">
                    <div className="flex items-center mb-4">
                      {/* รูปภาพ thumbnail แบบวงกลม */}
                      <div className="mr-4 flex-shrink-0">
                        <img 
                          src={tool.thumbnail || 'https://via.placeholder.com/80'} 
                          alt={tool.name}
                          className="w-16 h-16 rounded-full object-cover border-2 border-purple-500"
                        />
                      </div>
                      <h3 className="text-xl font-bold text-white">{tool.name}</h3>
                    </div>
                    <p className="text-gray-400 mb-4 line-clamp-3">{tool.description}</p>
                    <div className="flex justify-between items-center">
                      <Link 
                        to={`/tools/${tool.id}`} 
                        className="text-purple-400 hover:text-purple-300 transition-colors"
                      >
                        รายละเอียดเพิ่มเติม
                      </Link>
                      <a 
                        href={tool.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors"
                      >
                        เข้าใช้งาน
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* แสดงข้อความเมื่อไม่มีเครื่องมือ */}
          {!loading && !error && tools.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-400 text-lg">ยังไม่มีเครื่องมือในขณะนี้</p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}